import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useMedia } from 'react-use';
// import PlayIcon from "@images/play-img.png";
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import SwiperCore from 'swiper';
import { Autoplay, Navigation, Scrollbar } from 'swiper/modules';
import { MoviesQueryModel, RowConfig } from '../../types';
import 'swiper/scss';
import 'swiper/scss/navigation';
import Item from '../Item';


const SwipperControl = ({ data }: any) => {
  const swipper = useSwiper();

  useEffect(() => {
    let timer: any = null;
    if (!data.length) return;
    const itemId = sessionStorage.getItem('homeScrollContent');
    const id = sessionStorage.getItem('homeScrollContentId');
    if (itemId && id) {
      const dataIndex = data.findIndex((d: any) => `${d.id}` === itemId);
      if (dataIndex !== -1) {
        timer = setTimeout(() => {
          const swiperId = sessionStorage.getItem('homeScrollContentId');
          const swiperActiveId = sessionStorage.getItem('homeScrollSwiperId');
          const swuperActiveIndex = data.findIndex((d: any) => `${d.id}` === swiperActiveId);
          if (swiperId) {
            swipper && swipper.slideTo(swuperActiveIndex);
            const el = document.getElementById(`swiper-${swiperId}`);
            if (el) {
              try {
                el.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
              } catch (e) {
                el.scrollIntoView(true);
              }
            }
            sessionStorage.removeItem('homeScrollContentId');
            sessionStorage.removeItem('homeScrollContent');
            sessionStorage.removeItem('homeScrollSwiperId');
          }
        }, 2000);

        return () => clearTimeout(timer);  // Clean up the timer on component unmount
      }
    }
  }, [data, swipper]);


  return null;
};

type Props = {
  data: MoviesQueryModel['row_0']['data'] | any;
  config?: RowConfig;
  type: 'movies' | 'scenes';
  big: boolean;
  id?: number | string
  rawType?: string
  useSwiperControl?: boolean
};

const RecommendedItem: FC<Props> = ({ data, config, type, big = false, id, rawType, useSwiperControl = true }) => {

  const isMobile = useMedia('(max-width: 640px)');
  const isTablet = useMedia('(min-width: 641px) and (max-width: 1023px)');
  const isDesktop = useMedia('(min-width: 1024px)');
  const [disabledButton, setDisabledButton] = useState<boolean>(true);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = useCallback((swiper: any) => {
    setActiveIndex(swiper.activeIndex);
  }, [setActiveIndex]);

  useEffect(() => {
    const resizeEvent = () => window.dispatchEvent(new Event('resize'));
    resizeEvent();  // Trigger resize once on mount.
  }, []);

  const itemsNum = useMemo(() => {
    if (type === 'movies') {
      if (isMobile) return 2;
      if (isTablet) return 4;
      return big ? 6 : 7;
    } else if (type === 'scenes') {
      if (isMobile) return 1;
      if (isTablet) return 3;
      return isDesktop ? 5 : 7;
    }
    return 7;
  }, [type, isMobile, isTablet, isDesktop, big]);



  const activeId =  data[activeIndex]?.id;

  return (
    <Swiper
      modules={[Navigation, Scrollbar, Autoplay]}
      onSlideChange={handleSlideChange}
      className={`beate-swiper${type==='scenes' ? ' scenes' : ''}${disabledButton ? ' disabledSwipeArrow' : ''}`}
      slidesPerView={itemsNum}
      loopAdditionalSlides={itemsNum - 1}
      spaceBetween={30}
      slidesPerGroup={1}
      navigation={true}
      loop={true}
      scrollbar={{ draggable: true }}
      id={`swiper-${id ? id : rawType}`}
      onNavigationNext={() => setDisabledButton(false)}
      autoplay={config?.automaticCarousel ? { delay: 2500, disableOnInteraction: false } : false}
    >
      {useSwiperControl && <SwipperControl data={data} id={id} type={rawType} />}
      {data?.length
        ? data.map((item: any, index: any) =>  (
            <SwiperSlide key={item.id} className={`${type !== 'scenes' ? 'swiper-slide-item' : ''}`}>
              <Item item={item} id={id} type={type} rawType={rawType} index={index + 1} swiperActiveId={activeId}/>
            </SwiperSlide>
        ))
        : null}
    </Swiper>
  );
};
export default RecommendedItem;
